module.exports = {
  templateUrl: 'signin/components/register/register.html',
  controller: class Register {

    static $inject = [
      '$ngRedux',
      '$scope',
      '$state',
      '$translate',
      'RegistrationService',
      'ProductService',
      'ValidationService',
      'SecurityService',
    ];

    options = {
      gender: {
        required: true,
      },
      firstName: {
        maxlength: 50,
        required: true,
        trim: true,
      },
      lastName: {
        maxlength: 50,
        required: true,
        trim: true,
      },
      birthdate: {
        required: true,
      },
      hin: {
        required: true,
        years: 10,
      },
      city: {
        maxlength: 255,
        required: true,
        trim: true,
      },
      phone: {
        maxlength: 50,
        required: true,
        trim: true,
      },
      hinExpirationMonth: {
        required: true,
      },
      hinExpirationYear: {
        required: true,
      },
      email: {
        required: true,
      },
      password: {
        required: true,
        maxlength: 256,
        minlength: 8,
      },
      contactMethodKinds: ['home', 'mobile', 'work', 'other'],
    };

    constructor(
      $ngRedux,
      $scope,
      $state,
      $translate,
      RegistrationService,
      ProductService,
      ValidationService,
      SecurityService
    ) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
      this.$translate = $translate;
      this.RegistrationService = RegistrationService;
      this.ProductService = ProductService;
      this.ValidationService = ValidationService;
      this.SecurityService = SecurityService;
    }

    $onInit() {
      this.setStateConnection();
      this.RegistrationService.initializeStates();

      this.firstNameTranslateValue = { value: this.options.firstName.maxlength };
      this.lastNameTranslateValue = { value: this.options.lastName.maxlength };
      this.cityTranslateValue = { value: this.options.city.maxlength };
      this.phoneTranslateValue = { value: this.options.phone.maxlength };
      this.hasMandatoryFields = this.clinic.mandatoryFieldsBeforeBooking;
      this.hasValidateHinExpiration = this.clinic.hasValidateHinExpiration;
      this.hinExpirationMonths = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

      this.model = {
        mainPatient: {},
        manitoba: this.hasManitobaProduct(),
      };

      this.local = this.$state.params.locale || this.$translate.use();

      if (this.haveProductRegisterDelegationForm()) {
        this.model.linkedPatient = {};

        if (this.hasMandatoryFields) {
          this.model.linkedPatient.useSameContactInfo = true;
        }
      }
    }

    setStateConnection() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        clinic: state.group,
        isHospitalBooking: state.hospitalBooking.isHospitalBooking,
      }))(this));
    }

    hasErrors(ngModel) {
      return this.RegistrationService.hasErrors(ngModel);
    }

    states() {
      return this.RegistrationService.states.register;
    }

    showFullWidthMessage() {
      if (this.states().init) {
        return false;
      }
      if (this.states().activationEmailSent) {
        return true;
      }

      // Show no match message when main / linkedPatient is not created
      // or there is another error (i.e. HIN mismatch with birthdate).
      return (!this.states().sameClinic && !this.states().clinicAcceptsNewPatients) || this.states().linkedPatientError || this.states().errors;
    }

    submit() {
      // Reset email and HIN validity because the validation is done server-side
      this.form.email.$setValidity('alreadyTaken', true);

      this.availablePatientForms.forEach((patientForm) => {
        this.form[`${patientForm}_hin`].$setValidity('alreadyTaken', true);
      });

      if (this.hasMandatoryFields && this.validateHinExpiration) {
        this.handleHinExpiration();
      }

      if (this.form.$valid) {
        this.submitting = true;
        this.validate();
      }
    }

    validate() {
      this.model.groupId = this.clinic.id;
      const locale = this.$state.params.locale || this.$translate.use();
      this.SecurityService.logoutAccount().then(() => {
        this.RegistrationService.register(this.model, locale, this.hasMandatoryFields).then(this.validateSatisfied, this.validateFailed);
      });
    }

    validateSatisfied = (response) => {
      this.submitting = false;
      this.RegistrationService.states.register = response.data.states;
      if (response.data.error) {
        this.RegistrationService.states.register.errors = response.data.error;
      }
      if (response.data.otherClinics) {
        this.RegistrationService.clinics = response.data.otherClinics;
      }

      // Redirect to login when patient is already confirmed somewhere
      if (response.data.states.confirmed) {
        if (response.data.states.sameClinic || response.data.states.clinicAcceptsNewPatients) {
          if (response.data.states.sameEmail) {
            this.RegistrationService.registrationEmail = this.model.email;
          } else {
            this.RegistrationService.maskedEmail = response.data.states.maskedEmail;
          }
          this.$state.go('login', this.$state.params);
        }
      }
    };

    getCustomTokens(kindToken) {
      let filteredToken = [];

      if (this.clinic.customTokens && this.clinic.customTokens.length) {
        filteredToken = this.clinic.customTokens.filter(customToken => customToken.kind === kindToken && this.$translate.use() === customToken.locale);
      }

      if (filteredToken.length) {
        return filteredToken[0].token;
      }

      return null;
    }

    validateFailed = (response) => {
      this.submitting = false;
      if (response.status === 400 && response.data.error.code === 'email_already_exists') {
        this.form.email.$setValidity('alreadyTaken', false);
      } else if (response.status === 400 && response.data.error.code === 'hin_already_exists') {
        this.form.mainPatient_hin.$setValidity('alreadyTaken', false);
      } else {
        this.RegistrationService.states.register.init = false;

        if (response.data.error.code === 'link_patient') {
          this.RegistrationService.states.register.linkedPatientError = response.data.error.subcode;
        } else {
          this.RegistrationService.states.register.errors = true;
        }
      }
    };

    canSubmit() {
      if ((this.model == null)) {
        return false;
      }
      return this.RegistrationService.canSubmit(this.form);
    }

    haveProductRegisterDelegationForm() {
      return this.ProductService.isAvailable('PATIENT_REGISTER_DELEGATION_FORM');
    }

    hasManitobaProduct() {
      return this.ProductService.isAvailable('MANITOBA_BOOKING');
    }

    hasGenericHinProduct() {
      return this.ProductService.isAvailable('GENERIC_PHN');
    }

    onHinKeyDown(event, model, formControl) {
      const modelToUse = this.hasManitobaProduct ? this.model : model;
      return this.ValidationService.doHinValidation(event, this.clinic.validateHin, modelToUse, formControl, this.hasManitobaProduct);
    }

    onHinChanged(model, formControl) {
      const modelToUse = this.hasManitobaProduct ? this.model : model;
      return this.ValidationService.validateHin(formControl.$viewValue, modelToUse, this.hasManitobaProduct);
    }

    isRequired(field, patientForm) {
      return this.options[field] && (patientForm === 'mainPatient' || (this.model.linkedPatient && Object.keys(this.options).some(attribute => this.options[attribute].required && !!this.model.linkedPatient[attribute])));
    }

    get hinExpirationYears() {
      return _.times(this.options.hin.years, index => moment().add(index, 'years').year());
    }

    hinExpirationErrors(patientForm) {
      if (this.form && this.clinic.validateHinExpiration) {
        return this.form[`${patientForm}_hinExpirationMonth`].$error || this.form[`${patientForm}_hinExpirationYear`].$error;
      }
      return null;
    }

    handleHinExpiration() {
      const expiryYear = Number(this.form.mainPatient_hinExpirationYear.$viewValue);
      const expiryMonth = Number(this.form.mainPatient_hinExpirationMonth.$viewValue);

      if (!expiryYear || !expiryMonth) {
        this.form.mainPatient_hinExpirationMonth.$setValidity('required', false);
      } else {
        const validMainPatientHin = this.ValidationService.validateHinExpiryDate(expiryMonth, expiryYear);
        this.form.mainPatient_hinExpirationMonth.$setValidity('match', validMainPatientHin);
      }

      if (this.hasLinkedPatientHinExpiry) {
        const linkedExpiryYear = Number(this.form.linkedPatient_hinExpirationYear.$viewValue);
        const linkedExpiryMonth = Number(this.form.linkedPatient_hinExpirationMonth.$viewValue);
        if (!linkedExpiryYear || !linkedExpiryMonth) {
          this.form.linkedPatient_hinExpirationMonth.$setValidity('required', false);
        } else {
          const linkedPatient = this.ValidationService.validateHinExpiryDate(linkedExpiryMonth, linkedExpiryYear);
          this.form.linkedPatient_hinExpirationMonth.$setValidity('match', linkedPatient);
        }
      }
    }

    resetHinExpiryValidity() {
      if (this.mainPatientHinExpiryError) {
        this.resetMainPatientExpiry();
      }

      if (this.linkedPatientHinExpiryError) {
        this.resetLinkedPatientExpiry();
      }
    }

    resetMainPatientExpiry() {
      this.form.mainPatient_hinExpirationMonth.$setValidity('required', true);
      this.form.mainPatient_hinExpirationYear.$setValidity('required', true);
      this.form.mainPatient_hinExpirationMonth.$setValidity('match', true)
      this.form.mainPatient_hinExpirationYear.$setValidity('match', true);
    }

    resetLinkedPatientExpiry() {
      this.form.linkedPatient_hinExpirationMonth.$setValidity('required', true);
      this.form.linkedPatient_hinExpirationYear.$setValidity('required', true);
      this.form.linkedPatient_hinExpirationMonth.$setValidity('match', true);
      this.form.linkedPatient_hinExpirationYear.$setValidity('match', true);
    }

    replaceClinicNumberLabel(originalTranscription) {
      var clinicNumber = this.clinic.mainContactNumber;
      return originalTranscription.replace(
        "${clinicNumber}",
        clinicNumber
          ? (this.local === 'en' ? "at ".concat(clinicNumber) : "au ".concat(clinicNumber))
          : ""
      ).replace('  ', ' ');
    }

    get linkedPatientHinExpiryError() {
      return this.hasLinkedPatientHinExpiry && (this.form.linkedPatient_hinExpirationYear.$invalid || this.form.linkedPatient_hinExpirationMonth.$invalid);
    }

    get mainPatientHinExpiryError() {
      return this.form.mainPatient_hinExpirationYear.$invalid || this.form.mainPatient_hinExpirationMonth.$invalid;
    }

    get hasLinkedPatientHinExpiry() {
      return this.form.linkedPatient_hinExpirationYear && this.form.linkedPatient_hinExpirationYear.$viewValue;
    }

    get availablePatientForms() {
      return _.intersection(Object.keys(this.model), ['mainPatient', 'linkedPatient']);
    }

    get otherGenderAllowed() {
      return this.ProductService.isAvailable('OTHER_PATIENT_GENDER');
    }

    get hinMessageSuffix() {
      if (this.hasManitobaProduct() || this.hasGenericHinProduct()) {
        return 'phin';
      }
      return 'hin';
    }

    get hinMessageWhySuffix() {
      if (this.hasGenericHinProduct())
        return 'phn';
      if(this.hasManitobaProduct())
        return 'manitobaPhin';

      return 'defaultHin';
    }

    get signinWhyMessage(){
      return this.replaceClinicNumberLabel(
        this.$translate.instant('signin.messages.why.' + this.hinMessageWhySuffix)
      );
    }
  },
};



// WEBPACK FOOTER //
// ./signin/components/register/register.js